import * as React from 'react'
import styled from 'styled-components'

import Modal from '../../ui/Modal/Modal'
import { ConsentTitle, ConsentDescription } from '../CardConsent/CardConsent'

const StyledLink = styled.a`
  cursor: pointer;
`

const Container = styled.div`
  padding: 40px;
`

const Title = styled.h1`
  margin: 0;
  margin-bottom: 40px;
  font-size: 1.3rem;
  color: var(--color-primary);
`

const Content = styled.div`
  font-size: 0.875rem;
`

function ConsentModal({ children, zIndex, onClick, ...theProps }) {
  const [isModalShown, setModalShown] = React.useState(false)

  return (
    <StyledLink
      {...theProps}
      onClick={() => {
        onClick && onClick()
        setModalShown(true)
      }}
    >
      {children || <ConsentTitle />}
      <Modal
        id="consentModal"
        zIndex={zIndex}
        show={isModalShown}
        handleClose={e => {
          e.stopPropagation()
          setModalShown(false)
        }}
      >
        <Container>
          <Title>
            <ConsentTitle />
          </Title>
          <Content>
            <ConsentDescription />
          </Content>
        </Container>
      </Modal>
    </StyledLink>
  )
}

export default ConsentModal
